<div class="spur-toaster" aria-live="polite" aria-relevant="additions">
	@for (toast of toasts; track toast.id) {
	<div
		class="spur-toast"
		[class.spur-toast--success]="toast.type === 'success'"
		[class.spur-toast--error]="toast.type === 'error'"
		[attr.role]="toast.type === 'error' ? 'alert' : 'status'"
		[attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
		[style.--toast-duration]="toast.duration + 'ms'"
	>
		<span class="spur-toast__icon" aria-hidden="true">
			@if (toast.type === 'success') {
			<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M20 6.5L9.5 17L4 11.5"
					stroke="currentColor"
					stroke-width="2.4"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			} @else {
			<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12 7.25v6.5"
					stroke="currentColor"
					stroke-width="2.4"
					stroke-linecap="round"
				/>
				<circle cx="12" cy="16.75" r="1.35" fill="currentColor" />
			</svg>
			}
		</span>

		<div class="spur-toast__body">
			@if (toast.title) {
			<p class="spur-toast__title">{{ toast.title }}</p>
			}
			@if (toast.isHtml) {
			<div class="spur-toast__message" [innerHTML]="toast.message"></div>
			} @else {
			<p class="spur-toast__message">{{ toast.message }}</p>
			}
		</div>

		<button
			type="button"
			class="spur-toast__close"
			(click)="dismiss(toast.id)"
			[attr.aria-label]="'Dismiss ' + (toast.title || toast.type) + ' notification'"
		>
			<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
				<path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
			</svg>
		</button>

		<span class="spur-toast__progress" aria-hidden="true"></span>
	</div>
	}
</div>
